import { Button, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { LanguageType, LangValue } from '../../..'
import { LanguageSelectProps } from '../../types'

const useStyles = makeStyles((theme) => ({
  activeButton: {
    borderBottom: '4px solid #013862',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    color: 'black'
  },
  languageButton: {
    color: theme.palette.secondary.main
  }
}))

export const MobileLanguageSelect = ({
  languageOptions,
  selectUILanguage,
  UILanguage
}: LanguageSelectProps) => {
  const classes = useStyles()

  const onLanguageChange = (language: LangValue) => () => {
    selectUILanguage(language)
  }

  return (
    <Grid>
      {languageOptions.map((language: LanguageType) => (
        <Button
          className={
            UILanguage === language.value
              ? classes.activeButton
              : classes.languageButton
          }
          onClick={onLanguageChange(language.value)}
          aria-label={language.text}
          key={language.value}
          value={language.value}
        >
          {language.text}
        </Button>
      ))}
    </Grid>
  )
}
